import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useStore } from "@/store/AppStore";
import { PageHeader, Panel, Initials } from "@/components/kit";
import { ProcessManager } from "@/components/ProcessForms";
import { ChecklistManager } from "@/components/ChecklistForms";
import { ProofControl } from "@/components/Proof";
import { nameMap, pendingProofs } from "@/lib/selectors";
import { PROFILES } from "@/data/mock";

function PendingProofs({ state, cid, onReview }) {
  const pending = pendingProofs(state, cid);
  const names = nameMap(state);
  return (
    <Panel title="Provas aguardando aprovação" subtitle={`${pending.length} pendente(s)`} testId="pending-proofs-panel">
      {!pending.length && <p className="text-sm text-neutral-400">Nenhuma prova pendente.</p>}
      <ul className="divide-y divide-neutral-100">
        {pending.map(({ cl, item, idx }) => (
          <li key={`${cl.id}-${idx}`} data-testid={`pending-proof-${cl.id}-${idx}`} className="flex items-center gap-4 py-3.5">
            <Initials name={names[cl.collaboratorId]} />
            <div className="min-w-0 flex-1">
              <p className="line-clamp-2 text-sm font-semibold">{item.text}</p>
              <p className="text-xs text-neutral-500">{names[cl.collaboratorId]} · {cl.title}</p>
            </div>
            <ProofControl item={item} mode="owner" testId={`pending-review-${cl.id}-${idx}`} onReview={(s) => onReview(cl.id, idx, s)} />
          </li>
        ))}
      </ul>
    </Panel>
  );
}

export default function OwnerProcesses() {
  const { state, reviewProof } = useStore();
  const cid = PROFILES.empresaria.companyId;

  return (
    <div data-testid="owner-processes-page">
      <PageHeader eyebrow="Gestão de processos" title="Processos e checklists" subtitle="Padronize as rotinas da empresa e acompanhe a execução diária dos checklists e suas provas." />
      <Tabs defaultValue="processos">
        <TabsList className="bg-neutral-100 p-1">
          <TabsTrigger value="processos" data-testid="tab-processes" className="data-[state=active]:bg-white">Processos</TabsTrigger>
          <TabsTrigger value="checklists" data-testid="tab-checklists" className="data-[state=active]:bg-white">Checklists do dia</TabsTrigger>
        </TabsList>
        <TabsContent value="processos" className="mt-6">
          <ProcessManager companyId={cid} />
        </TabsContent>
        <TabsContent value="checklists" className="mt-6 space-y-8">
          <PendingProofs state={state} cid={cid} onReview={reviewProof} />
          <ChecklistManager companyId={cid} onReview={reviewProof} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
